export default __webpack_public_path__ + "static/media/left-arrow.eebfd3c8.svg";